import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavIconDashboard = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 14 14",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1288_20704)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M7 0.89093C3.13939 0.89093 0 4.03032 0 7.89093C0 8.25154 0.296971 8.54851 0.657577 8.54851C1.01818 8.54851 1.31515 8.25154 1.31515 7.89093C1.31515 4.75154 3.86061 2.20608 7 2.20608C10.1394 2.20608 12.6848 4.75154 12.6848 7.89093C12.6848 8.25154 12.9818 8.54851 13.3424 8.54851C13.703 8.54851 14 8.25154 14 7.89093C14 4.05154 10.8606 0.89093 7 0.89093Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M8.93031 3.98789C8.86667 3.96668 8.80303 3.96667 8.73939 3.96667C8.42121 3.96667 8.16667 4.17879 8.08182 4.47576L6.80909 9.12122C6.13031 9.18485 5.51515 9.6091 5.21818 10.2243C4.73031 11.2 5.13334 12.4091 6.10909 12.897C6.38485 13.0455 6.68182 13.1091 7 13.1091C7.76364 13.1091 8.44242 12.6849 8.78182 12.0061C9.01515 11.5394 9.05758 10.9879 8.88788 10.4788C8.76061 10.0758 8.48485 9.71516 8.14545 9.48183L9.41818 4.85758C9.50303 4.47576 9.29091 4.09395 8.93031 3.98789Z",
			fill: "currentColor"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1288_20704",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "currentColor"
		})
	}) })]
});
export default SvgNavIconDashboard;
